import '../styles/Skills.css';
import SkillCube from "./SkillCube";

const Skills = () => {
    return (
        <>
        <div className="skills">
            <div className="frontend">
                <ul>
                    <li><img src="./images/frontend.png" alt="" /></li>
                    <li><h1>Frontend Design & Dev</h1></li>
                    <li><p>I'm a frontend designer and developer who loves building websites that look great and work well. I focus on creating clear, responsive designs that are easy for everyone to use on any device. I use Figma to sketch out my ideas and create detailed prototypes, so I can see exactly how a design will look before I start coding. I enjoy taking complex concepts and turning them into simple, user-friendly layouts that meet real needs. I work hard to combine my creative design skills with solid coding abilities to deliver websites that are both beautiful and functional. My goal is to build digital experiences that are intuitive and enjoyable for users, while also meeting the goals of each project.</p></li>
                </ul>
            </div>
            <div className="backend">
                <ul>
                    <li><img src="./images/backend.png" alt="" /></li>
                    <li><h1>Backend Dev</h1></li>
                    <li><p>I'm a skilled backend developer with a good foundation in both Python and Node.js. I excel at building scalable, secure, and high-performance server-side applications, APIs, and microservices that power modern web experiences. Whether I'm working with Python's powerful libraries or leveraging Node.js for its event-driven architecture, I focus on writing clean, efficient code and ensuring seamless integration with databases and third-party services. My passion lies in creating reliable systems that support dynamic applications while keeping user data secure and operations smooth.</p></li>
                </ul>
            </div>
        </div>
        <hr  id='skills' />
        <h1 id='skillTop'>My Skills and Tools</h1>
            <div className="tools">
                <ul>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/html.png" alt="" /></span>
                        <span>HTML</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/css.png" alt="" /></span>
                        <span>CSS</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/js.png" alt="" /></span>
                        <span>JavaScript</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/react.webp" alt="" /></span>
                        <span>React Js</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/python.png" alt="" /></span>
                        <span>Python</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/scss.png" alt="" /></span>
                        <span>SCSS</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/git.png" alt="" /></span>
                        <span>Git</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/nodejs.png" alt="" /></span>
                        <span>Node Js</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/express.png" alt="" /></span>
                        <span>Express Js</span>
                    </li>
                    <li>
                        <span id='simg'><img src="./images/skillsImg/figma.png" alt="" /></span>
                        <span>Figma</span>
                    </li>
                </ul>
            </div>
        <SkillCube />
        <h1 id='skillTop'>Additional Skills</h1>
            <div className="otherSkills">
                <ul>
                    <li>UI/UX Design</li>
                    <li>Data Stuctures & Algorithms</li>
                    <li>Web Development</li>
                </ul>
            </div>
        <hr id='projects' />
        </>
    )
}

export default Skills;